import { LanguageName } from '../../enums/language-name.enum';
import { LanguageCode } from '../../enums/language-service.enum';

export class MapboxLanguageDictionary {

  public language = [
    { code: LanguageCode.af, name: LanguageName.af },
    { code: LanguageCode.ru, name: LanguageName.ru },
    { code: LanguageCode.de, name: LanguageName.de },
    { code: LanguageCode.es, name: LanguageName.es },
    { code: LanguageCode.fr, name: LanguageName.fr },
    { code: LanguageCode.pt, name: LanguageName.pt },
    { code: LanguageCode.ja, name: LanguageName.ja },
    { code: LanguageCode.ko, name: LanguageName.ko },
    { code: LanguageCode.en, name: LanguageName.en },
    { code: LanguageCode.zh, name: LanguageName.zh },
  ];

}
